import { Pipe, PipeTransform } from '@angular/core';

import { ProductLine } from '../../interfaces/checkout.interface';

@Pipe({
    name: 'productLineType',
    pure: true,
    standalone: true,
})
export class ProductLineTypePipe implements PipeTransform {
    transform(items: ProductLine[], priceType: string, hideOptionsAndAccessories?: boolean): ProductLine[] {
        if (!items) {
            return [];
        } else if (!priceType) {
            return items;
        }

        const accessoriesAndOptionsSet = ['option_salable', 'accessory', 'offer_partner'];

        return items.filter(
            (product) =>
                product.type === priceType &&
                (hideOptionsAndAccessories ? !accessoriesAndOptionsSet.includes(product.productType) : true) &&
                product.gencode !== 'EPD0000000',
        );
    }
}
